// @material-ui/core
import { Avatar } from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";
import { Link } from "react-router-dom";

const styles = theme => ({
  avatar: {
    border: "2px solid white",
    width: 4 * theme.spacing.unit,
    height: 4 * theme.spacing.unit
  }
});

class Profile extends Component {
  render() {
    const { classes } = this.props;

    let profile = {
      imageUrl: ""
    };

    if (this.props.profile) {
      profile = this.props.profile;
    }

    return (
      <Link to="/profile">
        <Avatar
          alt={profile.name}
          src={profile.imageUrl}
          className={classes.avatar}
        />
      </Link>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Profile);



// WEBPACK FOOTER //
// ./src/appBar/Profile.js